import React, { useState } from 'react'
import { Mail, Phone, MapPin, Send } from 'lucide-react'
import toast from 'react-hot-toast'

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    toast.success('Message sent! We\'ll get back to you soon.', {
      icon: '✉️',
      style: {
        borderRadius: '10px',
        background: '#10b981',
        color: '#fff',
      },
    })
    setFormData({ name: '', email: '', message: '' })
  }

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  return (
    <section data-component-path="client/src/components/Contact.jsx" data-component-line="35:5" data-component-id="client/src/components/Contact.jsx:35:5" id="contact" className="py-20 bg-gray-50">
      <div data-component-path="client/src/components/Contact.jsx" data-component-line="36:7" data-component-id="client/src/components/Contact.jsx:36:7" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div data-component-path="client/src/components/Contact.jsx" data-component-line="37:9" data-component-id="client/src/components/Contact.jsx:37:9" className="text-center mb-16">
          <h2 data-component-path="client/src/components/Contact.jsx" data-component-line="38:11" data-component-id="client/src/components/Contact.jsx:38:11" className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Get In Touch
          </h2>
          <p data-component-path="client/src/components/Contact.jsx" data-component-line="41:11" data-component-id="client/src/components/Contact.jsx:41:11" className="text-xl text-gray-600 max-w-2xl mx-auto">
            Have questions? We'd love to hear from you. Send us a message and we'll respond as soon as possible.
          </p>
        </div>

        <div data-component-path="client/src/components/Contact.jsx" data-component-line="46:9" data-component-id="client/src/components/Contact.jsx:46:9" className="grid lg:grid-cols-2 gap-12">
          <div data-component-path="client/src/components/Contact.jsx" data-component-line="47:11" data-component-id="client/src/components/Contact.jsx:47:11">
            <h3 data-component-path="client/src/components/Contact.jsx" data-component-line="48:13" data-component-id="client/src/components/Contact.jsx:48:13" className="text-2xl font-bold text-gray-900 mb-6">Contact Information</h3>
            <div data-component-path="client/src/components/Contact.jsx" data-component-line="49:13" data-component-id="client/src/components/Contact.jsx:49:13" className="flex flex-col gap-4">
              <div data-component-path="client/src/components/Contact.jsx" data-component-line="50:15" data-component-id="client/src/components/Contact.jsx:50:15" className="flex items-start gap-3">
                <div data-component-path="client/src/components/Contact.jsx" data-component-line="51:17" data-component-id="client/src/components/Contact.jsx:51:17" className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <Phone data-component-path="client/src/components/Contact.jsx" data-component-line="52:19" data-component-id="client/src/components/Contact.jsx:52:19" className="w-6 h-6 text-green-600" />
                </div>
                <div data-component-path="client/src/components/Contact.jsx" data-component-line="54:17" data-component-id="client/src/components/Contact.jsx:54:17">
                  <p data-component-path="client/src/components/Contact.jsx" data-component-line="55:19" data-component-id="client/src/components/Contact.jsx:55:19" className="font-semibold text-gray-900">Phone</p>
                  <p data-component-path="client/src/components/Contact.jsx" data-component-line="56:19" data-component-id="client/src/components/Contact.jsx:56:19" className="text-gray-600">+1 (555) 123-4567</p>
                </div>
              </div>

              <div data-component-path="client/src/components/Contact.jsx" data-component-line="60:15" data-component-id="client/src/components/Contact.jsx:60:15" className="flex items-start gap-3">
                <div data-component-path="client/src/components/Contact.jsx" data-component-line="61:17" data-component-id="client/src/components/Contact.jsx:61:17" className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <Mail data-component-path="client/src/components/Contact.jsx" data-component-line="62:19" data-component-id="client/src/components/Contact.jsx:62:19" className="w-6 h-6 text-green-600" />
                </div>
                <div data-component-path="client/src/components/Contact.jsx" data-component-line="64:17" data-component-id="client/src/components/Contact.jsx:64:17">
                  <p data-component-path="client/src/components/Contact.jsx" data-component-line="65:19" data-component-id="client/src/components/Contact.jsx:65:19" className="font-semibold text-gray-900">Email</p>
                  <p data-component-path="client/src/components/Contact.jsx" data-component-line="66:19" data-component-id="client/src/components/Contact.jsx:66:19" className="text-gray-600">hello@freshharvest.com</p>
                </div>
              </div>

              <div data-component-path="client/src/components/Contact.jsx" data-component-line="70:15" data-component-id="client/src/components/Contact.jsx:70:15" className="flex items-start gap-3">
                <div data-component-path="client/src/components/Contact.jsx" data-component-line="71:17" data-component-id="client/src/components/Contact.jsx:71:17" className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <MapPin data-component-path="client/src/components/Contact.jsx" data-component-line="72:19" data-component-id="client/src/components/Contact.jsx:72:19" className="w-6 h-6 text-green-600" />
                </div>
                <div data-component-path="client/src/components/Contact.jsx" data-component-line="74:17" data-component-id="client/src/components/Contact.jsx:74:17">
                  <p data-component-path="client/src/components/Contact.jsx" data-component-line="75:19" data-component-id="client/src/components/Contact.jsx:75:19" className="font-semibold text-gray-900">Address</p>
                  <p data-component-path="client/src/components/Contact.jsx" data-component-line="76:19" data-component-id="client/src/components/Contact.jsx:76:19" className="text-gray-600">123 Farm Road, Green Valley, CA 94000</p>
                </div>
              </div>
            </div>

            <div data-component-path="client/src/components/Contact.jsx" data-component-line="81:13" data-component-id="client/src/components/Contact.jsx:81:13" className="mt-8 p-6 bg-green-50 rounded-xl">
              <h4 data-component-path="client/src/components/Contact.jsx" data-component-line="82:15" data-component-id="client/src/components/Contact.jsx:82:15" className="font-bold text-gray-900 mb-2">Business Hours</h4>
              <p data-component-path="client/src/components/Contact.jsx" data-component-line="83:15" data-component-id="client/src/components/Contact.jsx:83:15" className="text-gray-600">Monday - Friday: 8:00 AM - 8:00 PM</p>
              <p data-component-path="client/src/components/Contact.jsx" data-component-line="84:15" data-component-id="client/src/components/Contact.jsx:84:15" className="text-gray-600">Saturday - Sunday: 9:00 AM - 6:00 PM</p>
            </div>
          </div>

          <div data-component-path="client/src/components/Contact.jsx" data-component-line="89:11" data-component-id="client/src/components/Contact.jsx:89:11" className="bg-white p-8 rounded-2xl shadow-lg">
            <form data-component-path="client/src/components/Contact.jsx" data-component-line="90:13" data-component-id="client/src/components/Contact.jsx:90:13" onSubmit={handleSubmit} className="space-y-6">
              <div data-component-path="client/src/components/Contact.jsx" data-component-line="91:15" data-component-id="client/src/components/Contact.jsx:91:15">
                <label data-component-path="client/src/components/Contact.jsx" data-component-line="92:17" data-component-id="client/src/components/Contact.jsx:92:17" htmlFor="name" className="block text-sm font-semibold text-gray-900 mb-2">
                  Your Name
                </label>
                <input
                  data-component-path="client/src/components/Contact.jsx" 
                  data-component-line="96:19" 
                  data-component-id="client/src/components/Contact.jsx:96:19"
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full h-11 px-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200"
                  placeholder="John Doe"
                />
              </div>

              <div data-component-path="client/src/components/Contact.jsx" data-component-line="109:15" data-component-id="client/src/components/Contact.jsx:109:15">
                <label data-component-path="client/src/components/Contact.jsx" data-component-line="110:17" data-component-id="client/src/components/Contact.jsx:110:17" htmlFor="email" className="block text-sm font-semibold text-gray-900 mb-2">
                  Email Address
                </label>
                <input
                  data-component-path="client/src/components/Contact.jsx" 
                  data-component-line="114:19" 
                  data-component-id="client/src/components/Contact.jsx:114:19"
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full h-11 px-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200"
                  placeholder="john@example.com"
                />
              </div>

              <div data-component-path="client/src/components/Contact.jsx" data-component-line="127:15" data-component-id="client/src/components/Contact.jsx:127:15">
                <label data-component-path="client/src/components/Contact.jsx" data-component-line="128:17" data-component-id="client/src/components/Contact.jsx:128:17" htmlFor="message" className="block text-sm font-semibold text-gray-900 mb-2">
                  Message
                </label>
                <textarea
                  data-component-path="client/src/components/Contact.jsx" 
                  data-component-line="132:19" 
                  data-component-id="client/src/components/Contact.jsx:132:19"
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="5"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200 resize-none"
                  placeholder="Tell us how we can help you..."
                ></textarea>
              </div>

              <button
                data-component-path="client/src/components/Contact.jsx" 
                data-component-line="146:17" 
                data-component-id="client/src/components/Contact.jsx:146:17"
                type="submit"
                className="w-full h-11 px-6 bg-green-600 text-white rounded-lg hover:bg-green-700 flex items-center justify-center gap-2 font-semibold shadow-md hover:shadow-lg transition-all duration-200 focus:ring-4 focus:ring-green-300/50"
              >
                Send Message
                <Send data-component-path="client/src/components/Contact.jsx" data-component-line="152:17" data-component-id="client/src/components/Contact.jsx:152:17" className="w-5 h-5 flex-shrink-0" />
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Contact